import { COLORS } from '../theme';

export default {
  styleOverrides: {
    root: {
      color: COLORS.black60,
      '&.Mui-disabled': {
        color: COLORS.black30,
      },
      '&.Mui-focused, &.MuiInputLabel-shrink': {
        color: COLORS.black30,
      },
      '&.MuiFormLabel-colorSuccess': {
        color: COLORS.greenDark,
      },
      '&.MuiFormLabel-colorError': {
        color: COLORS.redDark,
      },
    },
  },
};
